import namespace from "@rdfjs/namespace";
export const geor = namespace("http://www.opengis.net/def/rule/geosparql/");
